<template lang="pug">
  .wrap
    .message(:class="messageClass")
      .body(v-html="formattedBody")
      small(v-if="message.status === 'sending'") sending
      small.error(v-if="message.status === 'error'", @click='resend') try again

</template>

<script>

let renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
  if (!text) {
    text = href
  }

  if (text && (text.length > 27)) {
    text = text.substring(0, 27) + '...'
  }
  return `<a href="${href}" target="_blank">${text}</a>`
}

export default {
  name: 'message',
  props: ['message'],
  data () {
    return {
    }
  },
  computed: {
    formattedBody () {
      let formattedBody = marked(this.message.object.body || '', { renderer: renderer })
      //console.log(formattedBody)
      return formattedBody
    },
    messageClass () {
      let type = 'user'
      if (this.message.type === 'messageFromCandidatePosted') {
        type = 'candidate'
      } else if (this.message.type === 'autoResponse') {
        type = 'auto'
      }
      return type
    }
  },
  methods: {
    resend () {
      //console.log(this.message)
      this.$store.dispatch('resendPostMessageFromCandidate', this.message)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
@import('../assets/styles/_constants.styl')
.message
  margin 10px margin
  overflow hidden
  &.candidate
    text-align right
    & + .message.user
      margin-top margin * 2

  &.user + .message.candidate
    margin-top margin * 2

  .body
    background-color rgba(255,255,255,0.15)
    border-radius border-radius
    color #fff
    display inline-block
    font-family helvetica
    font-weight 400
    text-align left
    max-width 80%
    p
      line-height 1.3
      padding 15px 15px 0
      font-size: 14px
      &:last-child
        padding: 15px
    strong
      font-weight 500
    em
      font-style italic
    a
      color inherit
    ol, ul
      list-style-type disc
      margin-left 20px
      padding 15px 15px 15px
      li
        p
          padding 0 !important

  // auto response styling
  &.auto
    margin 20px 25px
    opacity .5
    .body
      background-color transparent
      max-width 100%
      p
        padding 0


small
  display block
  font-size 10px
  &.error
    color red

/* animations */
.message-enter-active, .message-leave-active
  transition all .3s ease
  .body
    transition all .3s ease
.message-enter, .message-leave-to
  opacity 0
  .body
    transform translate(0, 100%)
/*
.message-enter-active, .message-leave-active
  transition all .3s
.message-enter, .message-leave-to
  opacity 0
*/
</style>



// WEBPACK FOOTER //
// Message.vue?1d814560